module.exports = __webpack_public_path__ + "static/media/cq_messaggi b.076977bf.svg";